import { DrawCabinetShape, EShapeOrientation } from './DrawCabinetShape';
import { EShapeCabinetType } from '../../../core/ShapeTypes/EShapeCabinetType';
import { Length } from '../../../core/Length/Length';
import { Transform } from 'class-transformer';
import { LengthParser } from '../../../core/Length/LengthParser';

export class DrawS20CabinetShape extends DrawCabinetShape {

    @Transform(params => LengthParser.parse(params.value))
    D1!: Length;
    @Transform(params => LengthParser.parse(params.value))
    W1!: Length;
    @Transform(params => LengthParser.parse(params.value))
    DC!: Length;
    @Transform(params => LengthParser.parse(params.value))
    WC!: Length;

    get Shape(): EShapeCabinetType {
        return EShapeCabinetType.S20;
    }
}

